<app-offer-main
  [type]="'ata'"
  [projectInfo]="projectInfo"
  (updateProjectAtaNavCount)="updateProjectAtaNavCount()"
></app-offer-main>
